import {
  CalendarClockIcon,
  EyeIcon,
  TargetIcon,
  MessageCircleHeartIcon,
  PencilIcon,
  Repeat2Icon,
  SendHorizontalIcon,
  WandSparklesIcon,
  ZapIcon,
} from '@buffer-mono/popcorn'

import type { TakeawayCreatePostType } from '../../graphqlEnums'

import type { TakeawayItemCategory } from './types'

type TakeawayIcon = typeof EyeIcon

const TAKEAWAY_CATEGORY_ICONS: Partial<
  Record<TakeawayItemCategory, TakeawayIcon>
> = {
  engageAudience: MessageCircleHeartIcon,
  commentEngagement: MessageCircleHeartIcon,
  createPost: PencilIcon,
  publishDraft: SendHorizontalIcon,
  postingFrequency: CalendarClockIcon,
  updatePostingGoal: TargetIcon,
  repostPost: Repeat2Icon,
  boostLinkedIn: ZapIcon,
}

export function getTakeawayIcon({
  category,
  createPostType,
}: {
  category: TakeawayItemCategory
  createPostType?: TakeawayCreatePostType | null
}): TakeawayIcon {
  if (category === 'createPost' && createPostType === 'startWithAi') {
    return WandSparklesIcon
  }
  return TAKEAWAY_CATEGORY_ICONS[category] ?? EyeIcon
}
